// extracted by mini-css-extract-plugin
export var accentcolor = "#4eff00";
export var darkaccentcolor = "#00cc6d";
export var link = "FooterLink-module--link--23a81";
export var yellowaccent = "hsla(60, 90%, 50%, 1)";